/* C3 requires keys that have the actual variable names
 * which doesn't work with our regular SFetch.json as
 * it Auto camelizes everything.
 */

import SFetch from '@app/utils/sfetch'

const graphFetch = (url, options = {}) => {
  options.headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...options.headers,
  }

  return SFetch.raw(url, options).then((response) => response.json())
}

export default graphFetch
